export const scrollToOffer = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault()
  }
  const offerSection = document.getElementById('oferta')
  if (offerSection) {
    const yOffset = -80 // Offset for sticky header
    const y =
      offerSection.getBoundingClientRect().top + window.scrollY + yOffset
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
}
